import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { injectIntl, FormattedMessage } from "react-intl";
import styles from "./Page.module.css";

const PracticalityPage = ({ intl }) => {
  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({
            id: "practicality.title",
            defaultMessage: "Praticidade"
          })}{" "}
          - Vertex4D
        </title>
      </Helmet>
      <main>
        <header className={styles.pageHeader}>
          <div className={styles.container}>
            <div className={styles.breadcrumb}>
              <Link to="/">
                <FormattedMessage
                  id="breadcrumb.home"
                  defaultMessage="Início"
                />
              </Link>{" "}
              &gt;{" "}
              <span>
                <FormattedMessage
                  id="practicality.title"
                  defaultMessage="Praticidade"
                />
              </span>
            </div>
            <h1>
              <FormattedMessage
                id="practicality.title"
                defaultMessage="Praticidade"
              />
            </h1>
          </div>
        </header>
      </main>
    </>
  );
};

export default injectIntl(PracticalityPage);
